export enum NpoOnboardingRoutes {
  PREFERENCES = '/login/nonProfit/preferences',
  NOTIFICATIONS = '/login/notifications',
  LOCATION = '/login/location',
  NINE_NINETY_FORM = '/login/nonProfit/onBoarding/nineNintyForm',
  GENERAL = '/login/nonProfit/onBoarding',
  REVENUE = '/login/nonProfit/onBoarding/revenue',
  BACKGROUND_CHECKS = '/login/nonProfit/onBoarding/backgroundChecks',
  BOARD_DIRECTORS = '/login/nonProfit/onBoarding/boardDirectors',
  PASTORS = '/login/nonProfit/onBoarding/pastors',
  TOTAL_SALARIES = '/login/nonProfit/onBoarding/totalSalaries',
  PROFIT_AND_LOSS = '/login/nonProfit/onBoarding/pL',
  PARTY_AUDIT = '/login/nonProfit/onBoarding/partyAudit',
  IMPACT_STUDY = '/login/nonProfit/onBoarding/impactStudy',
  SALARIES = '/login/nonProfit/onBoarding/salaries',
  LAND_EQUIPMENTS = '/login/nonProfit/onBoarding/landEquipments',
  FUNDRAISING = '/login/nonProfit/onBoarding/fundraising',
  PROGRAMS = '/login/nonProfit/onBoarding/programs',
  TOTAL_GRANTS_PROGRAMS = '/login/nonProfit/onBoarding/totalGrantsPrograms',
  LIGHT_RATING_QUESTIONS = '/login/nonProfit/onBoarding/lightRatingQuestions',
  PROFILE = '/profile/npoProfile/insights'
}
